import {AccSingleInvReportModel} from "./acc-single-inv-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AccountInvoiceData} from "../../account-invoice/account-invoice.data";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-acc-single-inv-report",
    templateUrl: "./acc-single-inv-report.component.html",
    providers: [provideReportModel(AccSingleInvReportModel)]
})
export class AccSingleInvReportComponent extends AbstractReportPage {
    constructor(public model: AccSingleInvReportModel) {
        super();
    }

    populateAccountDetails(invoiceDetails: AccountInvoiceData): void {
        if (invoiceDetails == null) {
            this.model.data.ACCOUNTNAME = null;
            this.model.data.ACCOUNTNO = null;
            this.model.data.BILLINGCYCLE = null;
            this.model.data.RECEIPTNO = null;
            this.model.data.TERMSCOMMENT = null;
            this.model.data.TERMS = null;
            this.model.data.CREDITFOOTER = null;
            this.model.data.HEADER = null;
            this.model.data.FOOTER = null;
            this.model.data.DUEDATE = null;
        } else {
            this.model.data.ACCOUNTNAME = invoiceDetails.ACCOUNTNAME;
            this.model.data.ACCOUNTNO = invoiceDetails.ACCOUNTNO;
            this.model.data.BILLINGCYCLE = invoiceDetails.BILLINGCYCLE;
            this.model.data.RECEIPTNO = invoiceDetails.RECEIPTNO;
            this.model.data.TERMSCOMMENT = invoiceDetails.TERMSCOMMENT;
            this.model.data.TERMS = invoiceDetails.TERMS;
            this.model.data.CREDITFOOTER = invoiceDetails.CREDITFOOTER;
            this.model.data.HEADER = invoiceDetails.HEADER;
            this.model.data.FOOTER = invoiceDetails.FOOTER;
            this.model.data.DUEDATE = invoiceDetails.DUEDATE;
        }
    }
}
